export enum ReceiveServiceAction {
  All = 1,
  Partial = 2,
  RejectRemaining = 4,
  Nothing = 5,
  AlreadyReceived = 200,
}
